import React, { useState, useRef, useContext, useEffect } from 'react';
import UploadedFileIcon from "../../../../../assets/icons/upload-icon.svg";
import UploadedCompleteIcon from "../../../../../assets/icons/upload-complete.svg";
import DeleteFileIcon from "../../../../../assets/icons/delete-file.icon.svg";
import { ReactComponent as UploadIcon } from "../../../../../assets/icons/upload-icon.svg";
import { DocumentUploadBox, Flex, Space, UploadButton } from './style';
import { NetworkErrorAlertContext } from '../../../../../context/NetworkErrorAlert';

interface Props {
  onFileChange?: (file: File | null) => void;
  error?: string;
  previouslySavedLogo?: any;
}

const BusinessLogoUpload: React.FC<Props> = ({ onFileChange, error, previouslySavedLogo }) => {
  const [file, setFile] = useState<File | null>(null);
  const [uploadComplete, setUploadComplete] = useState<boolean>(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const { onShowAlert: onShowErrorAlert } =
    useContext(NetworkErrorAlertContext) || {};

  useEffect(() => {
    if (previouslySavedLogo) {
      setFile(previouslySavedLogo)
      setUploadComplete(true)
    }
  }, [previouslySavedLogo])

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;

      if (!['image/jpeg', 'image/png'].includes(fileType)) {
        onShowErrorAlert("", "Only JPEG and PNG files are allowed.");
        return;
      }

      if (fileSize > 5 * 1024 * 1024) {
        onShowErrorAlert("", "File size must be less than 5MB.");
        return;
      }

      setFile(selectedFile);
      setUploadComplete(false)
      onFileChange?.(selectedFile);
    }
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDeleteFile = () => {
    setFile(null);
    onFileChange?.(null);
    setUploadComplete(false)
  };

  return (
    <Space>
      {!file ? (
        <DocumentUploadBox>
          <input 
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange} 
            style={{ display: 'none' }} 
            ref={fileInputRef}
          />
          <Flex>
            <UploadButton onClick={handleUploadClick}>
              <UploadIcon />
              <div>
                <h4>Upload Business logo</h4>
                <span>JPEG or PNG less than 5MB</span>
              </div>
            </UploadButton>
          </Flex>
          {error && <p>{error}</p>}
        </DocumentUploadBox>
      ) : (
        <DocumentUploadBox>
          <Flex>
            <div className="uploaded-content">
              <img src={uploadComplete ? UploadedCompleteIcon : UploadedFileIcon} />
              <span>
                <p>{file.name}</p>
                <p className="uploaded-copy">{uploadComplete ? 'Uploaded' : 'Uploads when you continue'}</p>
              </span>
            </div>
            <button onClick={handleDeleteFile}>
              <img src={DeleteFileIcon}/>
            </button>
          </Flex>
        </DocumentUploadBox>
      )}
    </Space>
  );
}

export default BusinessLogoUpload;
